import isEmpty from 'lodash/isEmpty';
import { UserDTO, WIRTransverseRoles, WIRUser } from 'types/wellGuardian';

export const getIsSuperUser = (users: WIRUser[], user: UserDTO | null, countryState: string) =>
  !isEmpty(user?.igg) &&
  users
    .filter(
      item =>
        (item.roles?.includes(WIRTransverseRoles.WIR_SUPER_USER) ||
          item.roles?.includes(WIRTransverseRoles.WIR_DEVELOPER)) &&
        item.country?.includes(countryState),
    )
    .some(item => item.userId === user?.igg);


export const getIsInterventionEngineer = (users: WIRUser[], user: UserDTO | null, countryState: string) =>
  !isEmpty(user?.igg) &&
  users
    .filter(
      item =>
        (item.roles?.includes(WIRTransverseRoles.INTERVENTION_ENGINEER) ||
          item.roles?.includes(WIRTransverseRoles.WIR_DEVELOPER)) &&
        item.country?.includes(countryState),
    )
    .some(item => item.userId === user?.igg);
